import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["alert"]

    dismiss() {
        const alert = event.target.closest("[data-flash-target='alert']")
        this.closeAlert(alert)
    }

    connect() {
        this.alertTargets.forEach((alert) => {
            setTimeout(() => {
                this.closeAlert(alert)
            }, 5000)
        })
    }

    closeAlert(alert) {
        alert.style.transition = "opacity 0.5s ease-out"
        alert.style.opacity = "0"
        setTimeout(() => alert.remove(), 500)
    }
}
